/**
 * KAN-649: чистые функции кнопок "Написать" и "Отправить себе" у Telegram-аккаунта.
 * Без React и I/O: доступность, тексты, проверка формы.
 */
import { isPersonalTelegramAccount } from '@/lib/telegramPersonalAccount';
import type { TelegramAccount } from '@/types/telegramAccount';

export const TEXT_MAX = 4000;
export const SELF_RECIPIENT = 'self';

export const NEW_CHAT_WARNING =
  'Новый чат: считается в дневной лимит, частые сообщения незнакомым ведут к PeerFlood';
export const QUEUED_TOAST = 'Поставлено в очередь, уйдёт в течение минуты';
export const SEND_ERROR = 'Не удалось поставить сообщение в очередь';

export type SendMode = 'any' | 'self';

/** Писать можно с любого аккаунта, кроме основного, списанного и выключенного. */
export function canSendFromAccount(
  account: Pick<TelegramAccount, 'account_id' | 'decommissioned' | 'enabled' | 'personal_manager_id'>
): boolean {
  // KAN-871: с личного аккаунта менеджера прямой отправки нет (backend 409).
  return (
    account.account_id !== 'primary' &&
    !account.decommissioned &&
    account.enabled !== false &&
    !isPersonalTelegramAccount(account)
  );
}

/** Текст по умолчанию для "Отправить себе". */
export function defaultSelfText(account: Pick<TelegramAccount, 'label' | 'account_id'>): string {
  return `Проверка связи с аккаунта ${account.label || account.account_id}`;
}

/** Ошибка формы или ``null``: получатель нужен только в режиме "Написать". */
export function validateSend(mode: SendMode, recipient: string, text: string): string | null {
  if (mode === 'any' && !recipient.trim()) return 'Укажите получателя: @username или телефон';
  if (!text.trim()) return 'Введите текст сообщения';
  if (text.length > TEXT_MAX) return `Текст длиннее ${TEXT_MAX} символов`;
  return null;
}
